import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getSettingHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/setting/_layout/plan/")({
    component: BillingSettingsPage,
    staticData: {
        permissions: [PermissionEnum.SettingPlan],
        showInSideMenu: false,
        label: "pages.setting.plan.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.setting.plan.title"),
        };
    },
});

function BillingSettingsPage() {
    return (
        <TenantPage headerNavigationItems={getSettingHeaderItems} isEdit={true}>
            <></>
        </TenantPage>
    );
}
